import React from 'react';
import PropTypes from 'prop-types';
import { clsx, withSpacing } from '@wds/utils';

import useStyles from './useStyles';

export const displayOptions = Object.freeze([
  'block',
  'inline-block',
  'flex',
  'inline-flex',
  'inline',
]);
export const flexDirectionOptions = Object.freeze(['row', 'column']);
export const flexJustifyOptions = Object.freeze([
  'flex-start',
  'flex-end',
  'center',
  'space-between',
  'space-around',
  'space-evenly',
  'stretch',
]);
export const flexAlignOptions = Object.freeze([
  'start',
  'end',
  'center',
  'space-between',
  'space-around',
  'flex-start',
  'flex-end',
  'stretch',
  'baseline',
]);

const Box = ({
  element,
  children,
  containerRef,
  display,
  flexDirection,
  flexJustify,
  flexAlign,
  flexWrap,
  flexItemGrow,
  className,
  ...rest
}) => {
  const flexProperties = {
    flexDirection,
    flexJustify,
    flexAlign,
    flexWrap,
    flexItemGrow,
  };

  const classes = useStyles({
    display,
    flexProperties,
  });
  const Element = element;

  const classNames = clsx(classes.wdsBox, className);
  return (
    <Element className={classNames} ref={containerRef} {...rest}>
      {children}
    </Element>
  );
};

Box.defaultProps = {
  element: 'div',
  containerRef: undefined,
  display: undefined,
  flexDirection: undefined,
  flexJustify: undefined,
  flexAlign: undefined,
  flexWrap: undefined,
  flexItemGrow: undefined,
  className: undefined,
};

Box.propTypes = {
  element: PropTypes.string,
  children: PropTypes.node.isRequired,
  containerRef: PropTypes.func,
  /**
   * CSS display property
   */
  display: PropTypes.oneOf(displayOptions),
  /**
   * CSS flex-direction
   */
  flexDirection: PropTypes.oneOf(flexDirectionOptions),
  /**
   * CSS justify-content property
   */
  flexJustify: PropTypes.oneOf(flexJustifyOptions),
  /**
   * CSS align-items property
   */
  flexAlign: PropTypes.oneOf(flexAlignOptions),
  /**
   * Will wrap child items if needed, uses the flex-flow property
   */
  flexWrap: PropTypes.bool,
  /**
   * CSS flex-grow property
   */
  flexItemGrow: PropTypes.bool,
  /**
   * An internal prop that is being used by withSpacing HoC
   */
  className: PropTypes.string,
};

export default withSpacing(Box);
